const ItemGenerator = require('../../../game_items/ItemGenerator');
const Sword = require('../../../game_items/equipment/weapon/Sword');
const HeavyBoots = require('../../../game_items/equipment/boots/HeavyBoots.js');
const MedHelmet = require('../../../game_items/equipment/helmet/MedHelmet.js');
const LightTorsoe = require('../../../game_items/equipment/torsoe/LightTorsoe.js');
const getMobEquipmenAssignmentFromBags = require('../mobs/getMobEquipmenAssignmentFromBags');

const lich = (level) => {
  const handle = 'lich';
  const types = ['magic', 'undead'];
  const bags = [
    {
      items: [
        ItemGenerator.getCavernsMobItem(Sword, level),
        ItemGenerator.getCavernsMobItem(HeavyBoots, level),
        ItemGenerator.getCavernsMobItem(MedHelmet, level),
        ItemGenerator.getCavernsMobItem(LightTorsoe, level),
      ].map((item) => ({ value: item })),
    },
  ];
  const AI_PRIORITIES = ['interference', 'support', 'dps_ranged', 'dps_close', 'tank'];
  const equipped_abilities = [
    { value: 'move' },
    { value: 'melee_attack' },
    { value: 'devil_mask' },
    { value: 'infect_mind' },
    { value: 'summon_dwarf' },
    { value: 'summon_option' },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'flying_jelly_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          devil_mask: {
            handle: 'devil_mask',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          infect_mind: {
            handle: 'infect_mind',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          iron_will: {
            handle: 'iron_will',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
          summon_dwarf: {
            handle: 'summon_dwarf',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          summon_option: {
            handle: 'summon_option',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(6 + bound_level * 0.8 + Math.random() * 3),
      perception: Math.round(10 + bound_level * 1.3 + Math.random() * 3),
      mana: Math.round(11 + bound_level * 1.4 + Math.random() * 3),
      toughness: Math.round(8 + bound_level * 0.9 + Math.random() * 3),
      strength: Math.round(7 + bound_level * 0.8 + Math.random() * 3),
      willpower: Math.round(7 + bound_level * 0.9 + Math.random() * 3),
      dexterity: Math.round(11 + bound_level * 1.4 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 1500,
    drops_gold: true,
    drops_equipment: true,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities,
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = lich;
